<div class="custom-dialog-wrapper">
  <h1 mat-dialog-title class="custom-dialog-title">Edit Vendor Details</h1>
  <div mat-dialog-content>
    <div class="field-row">
      <div class="vendor-item label">Vendor name</div>
      <div class="vendor-item">{{ vendorDetail.Name }}</div>
    </div>
    <div class="field-row">
      <div class="vendor-item label">Vendor no.</div>
      <div class="vendor-item">{{ vendorDetail.VendorNumber }}</div>
    </div>
    <div class="field-row">
      <div class="vendor-item label">Vendor status</div>
      <div class="vendor-item">{{ vendorEdited.VendorStatus }}</div>
    </div>
    <div class="field-row">
      <div class="vendor-item label">Country</div>
      <div class="vendor-item">{{ vendorEdited.AddressCountryCode }}</div>
    </div>
    <div class="field-row">
      <div class="vendor-item label">Email address</div>
    </div>
    <div class="sub-label">RFQ released will be sent to the selected email.</div>
    <form [formGroup]="vendorEditForm">
      <mat-radio-group formControlName="rfqSelectedEmail">
        <mat-radio-button class="radio-btn" *ngFor="let option of emailOptions"
          [value]="option.id">{{option.value}}</mat-radio-button>
      </mat-radio-group>
      <ng-container *ngIf="EmailOptionControl.value === 'others'">
        <div class="input-block">
          <div class="vendor-item">Name</div>
          <input class="vendor-input" formControlName="name" />
        </div>
        <div class="input-block">
          <div class="vendor-item">Email</div>
          <input class="vendor-input" formControlName="email" type="email" />
          <mat-error *ngIf="!!OtherEmailInputControl.errors">Invalid email</mat-error>
        </div>
      </ng-container>
    </form>
    <app-input-justification *ngIf="purchaseType === 'tender' || purchaseType === 'dc'" [vendor]="vendorEdited"
      [Justification]="vendorEdited.Justification || ''" [isEdit]="true"
      (change)="justificationChange($event)"></app-input-justification>
  </div>
  <div mat-dialog-actions class="custom-dialog-buttons">
    <app-button class="padBtn cancel-button" name="Cancel" tabindex="0"
    (keypress)="dialogRef.close()" (click)="dialogRef.close()"></app-button>
    <app-button class="padBtn action-button" name="Update" type="flat-button" [disabled]="!!OtherEmailInputControl.errors"
      tabindex="0" (keypress)="!OtherEmailInputControl.errors && editVendor()"
      (click)="!OtherEmailInputControl.errors && editVendor()"></app-button>
  </div>
</div>